module.exports = __webpack_public_path__ + "static/img/ar.0d073530.svg";